import type { FC } from 'react'

import { ServiceDetail } from 'components'

const ServiceDetailPage: FC = () => <ServiceDetail />

export default ServiceDetailPage
